module.exports = __webpack_public_path__ + "img/img_42.d21b5c45.png";